import { render } from "./AddrIcon.vue?vue&type=template&id=17f4bbf0"
import script from "./AddrIcon.vue?vue&type=script&lang=js"
export * from "./AddrIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__